import * as React from 'react';
import { withTranslation, WithTranslation } from "react-i18next";
import './viewUpdateTaskModule.scss';
import { RouteComponentProps } from 'react-router-dom';
import { dialog, app } from "@microsoft/teams-js";
import { TFunction } from "i18next";
import moment from 'moment';


export interface IListItem {
    header: string,
    media: JSX.Element,
}

export interface IAction {
    title: string,
    link: string
}

export interface IUpdateState {
    updates: any,
    updateList: IUpdateDetails[]
}

export interface IUpdateDetails {
    Date: Date,
    Message: string,
}

interface viewStatusTaskModuleProps extends RouteComponentProps, WithTranslation { }

class viewUpdateTaskModule extends React.Component<viewStatusTaskModuleProps, IUpdateState> {
    readonly localize: TFunction;
    private initMessage = {
        id: "",
        title: "",
        actions: [],
        updates: "",
    };

    private card: any;

    constructor(props: viewStatusTaskModuleProps) {
        super(props);

        this.localize = this.props.t;
        let query = this.GetQueryParameters();
        var data = JSON.parse(query["updates"]);

        this.state = {
            updates: query["updates"],
            updateList: JSON.parse(query["updates"])
        };

        console.log(this.state.updateList);
    }

    private GetQueryParameters = () => {
        let queryParams: any = {};
        window.location.search.substring(1).split("&").forEach(function (item) {
            let s = item.split("="),
                k = s[0],
                v = s[1] && decodeURIComponent(s[1]);
            queryParams[k] = v;
        });
        return queryParams;
    }



    public async componentDidMount() {
        //let params = this.props.match.params;
        await app.initialize();
    }

    public render(): JSX.Element {
        return (
            <div className="updateModule">
                <table className="updateTable">

                    <tr>
                        <th style={{width: "250px"}}>Date</th>
                        <th>Update</th>
                    </tr>
                    {this.state.updateList.sort((a, b) => a.Date > b.Date ? 1 : -1).map((data, i) => {
                        // Return the element. Also pass key
                        return (<tr>
                            <td>
                                <div>{moment(new Date(data.Date!)).utc().format("MM/DD/YYYY hh:mm A z")}</div>
                                <div>{moment(new Date(data.Date!)).format("MM/DD/YYYY hh:mm A z")}</div>
                            </td>
                            <td style={{ whiteSpace: "pre-line" }}>{data.Message}</td>
                        </tr>)
                    })}
                </table>
            </div>
        );
    }

    private onClose = () => {
        dialog.url.submit();
    }
}

const viewUpdateTaskModuleWithTranslation = withTranslation()(viewUpdateTaskModule);
export default viewUpdateTaskModuleWithTranslation;